<template>
    <BrandDialogFilter v-model="localShowFilterDialog" :title="$t('Brands.Brands')" @cancel="handleCancel"
        @update:filteredbrands="handleConfirm" ref="dialogFilterbrands" :categories="flattenedCategories" 
        :suppliers="suppliers"/>

    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="BrandsList">

        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter :title="$t('Brands.Name')" :Filter="brandName" :getList="BrandsList"
                @cancel="brandName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="brandName" id="brandName" variant="outlined" maxlength="33"
                        hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <!--<template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('Brands.Description')" :Filter="Description" :getList="BrandsList"
                @cancel="Description = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="Description" id="Description" variant="outlined"
                        maxlength="33" hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>-->

        <template v-slot:[SlotsFilters.Filter1]>
            <ColumnFilter :title="$t('Brands.Category')" :Filter="FieldCategoryId" :getList="BrandsList"
                @cancel="FieldCategoryId = []">
                <template v-slot:input>
                     <autocompleteGrouped
                            v-model="FieldCategoryId"
                            :items="categories"
                            :placeholder="
                                $t('placeholder.select', {
                                    itm: $t('Brands.Category'),
                                })
                            "
                        />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter2]>
            <ColumnFilter :title="$t('Brands.Supplier')" :Filter="FieldSupplierId" :getList="BrandsList"
                @cancel="FieldSupplierId = null">
                <template v-slot:input>
                    <v-autocomplete
                            :style="MySupplier ? 'pointer-events: none;' : ''"
                            v-model="FieldSupplierId"
                             
                            :items="suppliers"
                            item-title="name"
                            item-value="supplierId"
                            persistent-placeholder
                            variant="outlined"
                            :placeholder="
                                $t('placeholder.select', {
                                    itm: $t('Brands.Supplier'),
                                })
                            "
                            hide-details
                        >
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item
                                    v-bind="props"
                                    variant="text"
                                    :id="index"
                                    :name="item.brandName"
                                >
                                    {{ item.brandName }}
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:[SlotsFilters.Filter3]>
            <ColumnFilter :title="$t('Brands.Created')" :Filter="FieldCreatedDate" :getList="BrandsList"
                @cancel="FieldCreatedDate = null">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="FieldCreatedDate" :min-date="new Date('2000-01-01')" :max-date="new Date()"
                            :model-value="FieldCreatedDate" range-enabled
                            @update:model-value="handleDateRangeCreationDate" />
                    </span>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.brandName }} </template>
       <!-- <template v-slot:[SlotsItems.item1]="{ item }">{{ item.description }}</template>-->
        <template v-slot:[SlotsItems.item1]="{ item }">
            {{ item.category.map(c => c.name).join(',') }}
        </template>
        <template v-slot:[SlotsItems.item2]="{ item }">
            {{ item.supplierDetails.supplierName }}
        </template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.created.split('T')[0] }}
            {{ item.created.split('T')[1].split('.')[0] }}</template>
        <template v-slot:edit="{ item, index }">
            <BrandActionMenu :Id="index" v-bind:idBrand="item.brandId"
                v-bind:getBrand="item" v-bind:getBrandListAfterDelete="BrandsList"
                />
        </template>
    </gridComponent>
</template>
<script>
import autocompleteGrouped from "@/genericComponent/autocompleteGrouped.vue";
import { getBrands } from '@/api/index';
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import DateField from '@/genericComponent/date-field.vue';
import BrandActionMenu from './BrandActionMenu.vue';
import BrandDialogFilter from './BrandDialogFilter.vue';
import { getAllCategories , isSupplier,
    idSupplier,getAllSuppliersForProducts  } from "@/api/index";
export default {
    components: {  GridComponent, ColumnFilter, DateField, BrandActionMenu, BrandDialogFilter , autocompleteGrouped },
    props: {
        showFilterDialog: Boolean,
        
    },
    mounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.BrandsList();
        });
        this.dialogFilterclientsRef = this.$refs.dialogFilterclients;
        this.fetchCategoriesAndSuppliers();
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            search: null,
            filterMenuitems: [1, 3, 4],
            brandName: null,
            FieldCategoryId : [],
            FieldCreatedDateFrom : null ,
            FieldCreatedDateTo : null,
            FieldSupplierId : null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            MySupplier :null,
            item:null,
            suppliers : [],
            categories: [],
        }
    },
    methods: {
         async fetchCategoriesAndSuppliers  ()  {
    try {
        const [categoriesResponse, suppliersResponse] = await Promise.all([
            getAllCategories(),
            getAllSuppliersForProducts(),
        ]);
        this.categories = categoriesResponse.data;
        this.suppliers = suppliersResponse.data;

        if (isSupplier()) {
            this.MySupplier = idSupplier();
            this.supplierId = this.MySupplier;
        }
    } catch (error) {
        console.error("Error fetching categories or suppliers:", error);
      }
    },
        handleNullableFilters() {
            this.brandName = null;
            this.Description = null;
            this.FieldAddress = null;
            this.FieldCompanyName = null;
            this.FieldStatus = null;
            this.FieldCreatedDate = null;
            this.$refs.dialogFilterclients.cleardialogfilter();
            this.BrandsList(1);
        },
        handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.FieldCreatedDateFrom = value[0];
                this.FieldCreatedDateTo = value[1];
            } else {
                this.FieldCreatedDateFrom = null;
                this.FieldCreatedDateTo = null;
            }
        },
        removeClient(selectedItem) {
            this.FieldSupplier.filter(i => i != selectedItem);
        },
        BrandsList: function (page) {
            if (page) { this.page = page }
            getBrands(this.page, this.PageSize, this.brandName, this.FieldCategoryId, this.FieldSupplierId,this.FieldCreatedDateFrom,this.FieldCreatedDateTo ,this.SortedBy, this.SortingType).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(filteredParams) {
            this.brandName = filteredParams.BrandName;
            this.FieldCategoryId = filteredParams.IdCategories;
            this.FieldSupplierId = filteredParams.supplierId;
            this.FieldCreatedDateFrom = filteredParams.CreatedFrom;
            this.FieldCreatedDateTo = filteredParams.CreatedTo;
            this.BrandsList();
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
         flattenedCategories () {
    const flatten = (cats, parentId = null, level = 0) => {
        return cats.reduce((acc, category) => {
            if (category.parent_category_id === parentId) {
                const flatCategory = {
                    ...category,
                    name: "  ".repeat(level) + category.name,
                };
                acc.push(flatCategory);
                acc.push(...flatten(cats, category.categoryId, level + 1));
            }
            return acc;
        }, []);
    };
    return flatten(this.categories);
    },
        headers() {
            const headers = [
                this.$t('Brands.Name'),
                this.$t('Brands.Category'),
                this.$t('Brands.Supplier'),
                this.$t('Brands.Created')
                
            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
                item5: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
                Filter5: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['20%', '35%', '25%', '20%'];
            return headers;
        },
       
    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
